/** Device and capability detection for voice capture. */

export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || ('ontouchstart' in window && window.innerWidth <= 1024)
  );
};

export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

export const isStandalonePwa = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
};

export const supportsWebSpeechRecognition = (): boolean => {
  if (typeof window === 'undefined') return false;
  return 'webkitSpeechRecognition' in window || 'SpeechRecognition' in window;
};

export const supportsMediaRecorderCapture = (): boolean => {
  if (typeof window === 'undefined') return false;
  return typeof MediaRecorder !== 'undefined' && Boolean(navigator.mediaDevices?.getUserMedia);
};

/**
 * Prefer server-side transcription via MediaRecorder when browser speech
 * recognition is unavailable OR when running on mobile browsers where Web
 * Speech is often inconsistent.
 */
export const shouldUseMediaRecorderFallback = (): boolean => {
  if (!supportsMediaRecorderCapture()) return false;
  if (!supportsWebSpeechRecognition()) return true;
  if (isMobileDevice()) return true;
  return false;
};

export const getPreferredMediaRecorderMimeType = (): string | undefined => {
  if (typeof MediaRecorder === 'undefined') return undefined;
  const types = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/aac'];
  return types.find((type) => MediaRecorder.isTypeSupported(type));
};
